import {Outlet, Link} from "react-router-dom";

const Layout = () => {
    return (
        <>
            <nav>
                <input type="checkbox" id="show-menu" role="button"/>
                <label htmlFor="show-menu" className="open"><span className="fa fa-bars"></span></label>
                <label htmlFor="show-menu" className="close"><span className="fa fa-times"/></label>
                <ul id="menu">
                    <li><Link to="/">Общие сведения</Link></li>
                    <li><Link to="/natural_resources">Природные ресурсы</Link></li>
                    <li><Link to="/exhibitions">Выставки</Link></li>
                    <li><Link to="/sport">Спорт</Link></li>
                    <li><Link to="/culture">Культура</Link></li>
                    <li><Link to="/types_of_tourism">Виды туризма</Link></li>
                    <li><Link to="/virtual_tours">Виртальные экскурсии</Link></li>
                    <li><Link to="/maps">Брестская область на карте</Link></li>
                    <li><Link to="/events">События</Link></li>
                    <li><Link to="/reference-information">Справочная информация</Link></li>
                    <li><Link to="/useful-information">Полезная информаци</Link></li>
                    <li><a href="http://brestobl.com/virt/tur.html">Доска объявлений: отдых, туризм, спорт</a></li>
                    <li><Link to="/investment-projects">Инвестиционные проекты Брестской области</Link></li>
                </ul>
            </nav>
            <Outlet/>
        </>
    )
};

export default Layout;
